import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { SelectItem } from '../../employees/employees.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { FormControl } from '@angular/forms';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { DataService } from 'app/shared/common/helper/http-service';
import { Configuration } from 'app/app.configuration';
import { ToastrService } from 'ngx-toastr';
import { ExcelService } from '../../scrumboard/excel.service';
import { MatDialog } from '@angular/material';
import Highcharts from 'highcharts';
const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'analytics-dashboard',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})

export class AnalyticsDashboardComponent implements OnInit {
  // ----- chart 1 -----
  // highcharts = Highcharts;
  // chartOptions = {
  //   title: {
  //     text: 'Analytics chart'
  //   },
  //   xAxis: {
  //     categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  //       "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  //   },
  //   yAxis: {
  //     title: {
  //       text: "values rate",
  //       color: '#2C3460'
  //     }
  //   },

  //   labels: {
  //     items: [{
  //       html: 'Employee Analytics chart',
  //       style: {
  //         left: '50px',
  //         top: '15px',
  //       }
  //     }]
  //   },
  //   series: [
  //     {
  //       type: 'column',
  //       name: 'Billable',
  //       data: [4, 3, 3, 9, 0, 6, 3, 8, 7, 2, 6, 3]
  //     },
  //     {
  //       type: 'column',
  //       name: 'Non-Billable',
  //       data: [2, 3, 5, 7, 6, 9, 0, 6, 3, 8, 7, 2]
  //     },
  //     {
  //       type: 'column',
  //       name: 'Bench',
  //       data: [3, 2, 1, 3, 4, 2, 3, 5, 7, 6, 9, 5]
  //     },

  //     {
  //       type: 'spline',
  //       name: 'Average',
  //       data: [3, 2.67, 3, 6.33, 3.33, 2.87, 8, 3.8, 7, 6.55, 3.25, 9.38]
  //     },
  //     {
  //       type: 'pie',
  //       name: 'Total consumption',
  //       data: [
  //         {
  //           name: 'Billable',
  //           y: 19,
  //         },
  //         {
  //           name: 'Non-Billable',
  //           y: 23,
  //         },
  //         {
  //           name: 'Bench',
  //           y: 13,
  //         }

  //       ],
  //       center: [100, 80],
  //       size: 100,
  //       showInLegend: false,
  //       dataLabels: {
  //         enabled: false
  //       }
  //     },
  //   ],
  //   colors: ['#3EB645E3', '#FF8181', '#0C8CE9', '#FFA500'],
  // };

  // ----- chart 2 -----

  // highcharts = Highcharts;
  // chartOptions = {
  //   chart: {
  //     type: 'bar',
  //     height: '500px',
  //   },
  //   title: {
  //     text: "Yearly Average Analytics",
  //     color: '#2C3460'
  //   },
  //   xAxis: {
  //     categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  //       "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  //   },
  //   yAxis: {
  //     title: {
  //       text: "Monthly basis",
  //       color: '#2C3460'
  //     }
  //   },
  //   tooltip: {
  //     valueSuffix: " "
  //   },
  //   series: [{
  //     name: 'Week Work Hours',
  //     data: [49.9, 92.5, 106.4, 129.2, 110.0, 130.0, 135.6, 128.5, 100.4, 120.1, 95.6, 54.4]

  //   }, {
  //     name: 'Week Break Hours',
  //     data: [40.6, 78.8, 98.5, 93.4, 106.0, 84.5, 105.0, 104.3, 91.2, 83.5, 106.6, 92.3]
  //   }],

  //   colors: ['#3EB645E3', '#FF8181'],
  // };


  widgets: any;
  formDate = new FormControl(moment());
  widget1SelectedYear = '2016';
  widget5SelectedDay = 'today';
  currentProjects: SelectItem[] = [];
  projectId = [];
  resourcesDetails: any = [];
  resourceStatusDetails: any = [];
  dataSettings: any;
  employeeDetails: any;
  resources = [];
  resourceStatus = [];
  resourceStatusWithBillingCount = [];
  type: string;
  resourceType: string;
  totalRecords: any;
  reportsList = [];
  reportDate = '';
  currentDate = new Date();
  locationDD = [];
  locationOptions: SelectItem[];
  roleDD = [];
  report: any;
  reportingList = [];
  reportingToDD = [];
  rollOptions: SelectItem[];
  deptDD = [];
  deptOptions: SelectItem[];
  reportingToOptions: SelectItem[];
  empRole = '';
  @ViewChild('dt', { static: false }) private resourceTable: any;
  watchLists = [];
  top25TimesheetRanks = [];
  resourceWorkedProject = [];
  loading = false;
  isDownloadAsExcel = false;
  cols = [
    { field: 'position', header: 'S.No' },
    { field: 'resourceImg', header: 'Profile' },
    { field: 'name', header: 'Name' },
    { field: 'projectName', header: 'Project Name' },
    { field: 'startDate', header: 'Start Date' },
    { field: 'endDate', header: 'End Date' }
  ];

  statusCols = [
    { field: 'position', header: 'S.No' },
    { field: 'resourceImg', header: 'Profile' },
    // { field: 'userId', header: 'userId' },
    { field: 'name', header: 'Name' },
    // { field: 'billableStatus', header: 'Billable / Non-Billable' },
    { field: 'totalExperience', header: 'Experience' },
    { field: 'department', header: 'Department' },
    { field: 'projectName', header: 'Project Name' },
    { field: 'reportingTo', header: 'Reporting To' }
  ];

  // ColsDateRange = [
  //   { field: 'position', header: 'S. No' },
  //   { field: 'name', header: 'Name' },
  //   { field: 'totalExperience', header: 'Experience' },
  //   { field: 'department', header: 'Department' },
  //   { field: 'projectName', header: 'Project Name' },
  //   { field: 'billableCount', header: 'Billable' },
  //   { field: 'nonBillableCount', header: 'Non-Billable' },
  //   { field: 'reportingTo', header: 'Reporting To' }
  // ];

  tabIndex: number;
  projectName: string;
  totalResourceRecords: any;
  selectbydate = new Date();
  startbydate = new Date();
  endbydate = new Date();

  resourceGraphData = [];
  // Primeng
  // public chartOptions = {
  //   scales: {
  //     yAxes: [{
  //       ticks: {
  //         stepSize: 10,
  //         beginAtZero: true
  //       }
  //     }]
  //   }
  // }
  view: any[] = [720, 520];
  ngxChartWidth = 2.5;
  // options
  showLabels: boolean = true;
  isDoughnut: boolean = false;
  legendPosition: string = 'below';
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showXAxisLabel = true;
  xAxisLabel = 'Resource status';
  showYAxisLabel = true;
  yAxisLabel = 'Resource Count';
  colorScheme = {
    domain: [
      '#64B5F6',
      '#76D7C4',
      '#B39DDB'
    ]
  };
  graphData: { labels: any[]; datasets: { data: any[]; backgroundColor: string[]; hoverBackgroundColor: string[]; }[]; };
  pieChartOptions = {
    legend: { display: false }
  }

  piegraphData = [];
  pieChartview: any[] = [700, 400];
  showLegend: boolean = true;
  projects = [];
  billingByRange: any;
  tenantId: string = '';
  isDownloadDisabled: boolean = true;

  /**
   * Constructor
   *
   * @param {AnalyticsDashboardService} _analyticsDashboardService
   */
  constructor(
    private parseService: ParseService,
    private hardCodedValues: HardCodedValues,
    private spinner: NgxSpinnerService,
    private storageConfiguration: StorageConfiguration,
    private dateService: DateServiceService,
    private getReportingToService: GetReportingToService,
    private dataService: DataService,
    private configuration: Configuration,
    private toastr: ToastrService,
    private excelService: ExcelService,
    public dialog: MatDialog,
  ) {

  }
  @ViewChild('secondDialog', { static: true }) secondDialog: TemplateRef<any>;

  // tslint:disable-next-line:typedef
  openDialog() {
    this.dialog.open(this.secondDialog);
  }

  /*
  ** ==========================================================
  ** On Init
  ** ==========================================================
  */
  async ngOnInit(): Promise<void> {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    let datePipe = new DatePipe('en-US');
    this.reportDate = datePipe.transform(new Date(), 'dd MMM yyyy');
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    this.dataSettings = await query.find();
    await this.getProjects();
    await this.getResourceStatus();

    this.getDepartment();
    this.getReportingTo();
  }

  /*
  ** ==========================================================
  ** Timesheet table filter
  ** ==========================================================
  */
  onFilter(event, dt): any {
    event.filteredValue.forEach((element, index) => {
      element.position = index + 1;
    });
    this.totalResourceRecords = event.filteredValue.length; // count of displayed rows
  }

  async getProjects() {
    this.projects = [];
    let profileClass = this.parseService.instance.Object.extend('Project');
    let query = new this.parseService.instance.Query(profileClass);
    query.containedIn('projectInfo.currentStatus', ['New', 'In Progress']);
    query.limit(100000);
    this.projects = await query.find();
  }

  onTenantIdChange(): void {
    this.isDownloadDisabled = !this.tenantId;
  }
  downloadReport(): void {
    this.spinner.show();
    this.dataService.getEmployeeReport(this.tenantId).subscribe(
      (responses: ArrayBuffer) => {
        const blob = new Blob([responses], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        this.saveExcelFile(blob);
        this.spinner.hide();
      },
      error => {
        console.error('Error downloading Excel report:', error);
      }
    )
  }
  saveExcelFile(blob: Blob) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Employee${new Date().toISOString().replace(/[:.]/g, '-')}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  async getResourceStatus() {
    this.resourceGraphData = [];
    let resourceGraphData = [];
    let labels = [];
    let data = [];

    this.spinner.show();
    let timeSheet = this.parseService.instance.Object.extend('ResourceStatus');
    let query = new this.parseService.instance.Query(timeSheet);
    query.include('user');
    query.include('user.profile');
    query.include('user.profile.department');
    query.include('user.profile.role');
    query.equalTo('tenantId', this.tenantId);
    let dateDifferent = this.dateService.startEndDateByDate(this.selectbydate);
    query.greaterThan('createdAt', dateDifferent[0]);
    query.lessThan('createdAt', dateDifferent[1]);
    query.limit(10000);
    await query.find().then(results => {
      let resourceStatusResult = results;
      let dataSettingsValues = this.dataSettings[0];
      let resourceDetails = [];
      let totalResources = [];
      // resourceStatusType = [{"value":"Dedicated Billable"},{"value":"Fixed Billable"},{"value":"Non-Billable"}]
      dataSettingsValues.get('resourceStatusType').forEach(element => {
        const percentage = resourceStatusResult.length / 100;
        let resourceArray = resourceStatusResult.filter(x => x.get('resourceStatus') === element.value);
        resourceDetails.push({ name: element.value, resources: resourceArray, percentage: resourceArray.length / percentage });
        totalResources.push(...resourceArray);
        resourceGraphData.push({
          'name': element.value,
          'value': resourceArray.length
        });

        this.piegraphData = resourceGraphData;

        labels.push(element.value);
        data.push(resourceArray.length);
        this.graphData = {
          labels: labels,
          datasets: [
            {
              data: data,
              backgroundColor: [
                '#64B5F6',
                '#76D7C4',
                '#B39DDB',
              ],
              hoverBackgroundColor: [
                '#64B5F6',
                '#76D7C4',
                '#B39DDB',
              ]
            }]
        };

      });
      resourceDetails.push({ name: 'All', resources: totalResources, percentage: 110 });
      this.resourceGraphData = resourceGraphData;
      this.resourceStatusDetails = resourceDetails;
      this.spinner.hide();
      this.cardClickEvent(this.resourceStatusDetails[0]);
    });
  }

  async cardClickEvent(event): Promise<any> {
    this.resourceStatus = [];
    this.resourceType = event.name;
    this.resourceStatus = await this.getTwilightResourceStatus(event.resources);
    this.totalResourceRecords = this.resourceStatus.length;
  }

  async getBillingByRange() {
    this.loading = true;
    this.resourceStatusWithBillingCount = [];
    // this.resourceType = event.name;
    this.resourceStatusWithBillingCount = await this.getTwilightResourceStatus(this.resourceStatusDetails[2].resources);
    this.totalResourceRecords = this.resourceStatusWithBillingCount.length;
    this.billingByRange = await this.getResourceBillableCount('');
    this.resourceStatusWithBillingCount.forEach((item, index) => {
      let billableCount = 0;
      let nonBillableCount = 0;
      let TotalDays = 0;
      ['Non-Billable', 'Dedicated Billable'].forEach(billingType => {
        const billingResult = this.billingByRange.filter((items) => items.user.objectId === item.userId && items.resourceStatus === billingType);
        if (billingType === 'Non-Billable') {
          nonBillableCount = billingResult.length;
        } else {
          billableCount = billingResult.length;
        }
        TotalDays += billingResult.length;
      });
      item['Resource_Name'] = item.name;
      item['Designation'] = item.designation;
      item['Department'] = item.department;
      item['Project_Name'] = item.projectName;
      item['Reporting_To'] = item.reportingTo;
      item['Total_Experience'] = item.totalExperience;
      item['Billable_Count'] = billableCount;
      item['Non_Billable_Count'] = nonBillableCount;
      item['Total_Days'] = TotalDays;

      delete item.userId;
      delete item.resourceImg;
      delete item.position;
      delete item.experience;
      delete item.name;
      delete item.designation;
      delete item.department;
      delete item.projectName;
      delete item.totalExperience;
      delete item.reportingTo;
    });
    // console.log('getResourceBillableCount after 3');
    // console.log('resourceStatusWithBillingCount', this.resourceStatusWithBillingCount);
    this.excelService.exportAsExcelFile(this.resourceStatusWithBillingCount, 'Resource-Analytics-With-BillingCount');
    this.loading = false;
  }


  async getTwilightResourceStatus(resources): Promise<any> {
    let result = [];
    for (const element of resources) {
      let profile = element.get('user').get('profile');

      this.resourceWorkedProject = [];
      let projects = [];
      for (const innerelement of element.get('projectId')) {
        let data = this.projects.filter(x => x.id == innerelement);
        if (data.length > 0) {
          projects.push(data[0].get('projectInfo').projectName);
        }
      }
      this.resourceWorkedProject = projects;
      let experienceInYear = (profile.get('officialInfo').experience != undefined) && (profile.get('officialInfo').experience.year != undefined)
        && (profile.get('officialInfo').experience.year != '') ? profile.get('officialInfo').experience.year : 0;
      let experienceInMonth = (profile.get('officialInfo').experience != undefined) && (profile.get('officialInfo').experience.month != undefined) &&
        (profile.get('officialInfo').experience.month != '') ? profile.get('officialInfo').experience.month : 0;

      let totalExperience = (experienceInYear + '.' + experienceInMonth + ' Year(s)');
      let userId = element.get('user').id;

      // let billableStatus  = await this.getResourceBillableCount(userId);


      result.push({
        position: 0,
        userId: element.get('user').id,
        resourceImg: profile.get('profileImageInfo').url == undefined ? this.hardCodedValues.defaultProfileImg : profile.get('profileImageInfo').url,
        name: profile.get('firstName') + ' ' + profile.get('lastName'),
        // billableStatus: '14/2',
        designation: profile.get('role') ? profile.get('role').get('name') : '',
        department: profile.get('department') ? profile.get('department').get('name') : '',
        reportingTo: profile.get('reportingTo').get('firstName') + ' ' + profile.get('reportingTo').get('lastName'),
        projectName: this.resourceWorkedProject.join(),
        totalExperience: totalExperience,
        experience: Number(experienceInYear + '.' + experienceInMonth),
      });
    }
    let res = result;
    res.sort(numberAs);
    function numberAs(a, b) {
      return b.experience - a.experience;
    }
    res.forEach((element, i) => {
      element.position = i + 1;
    });
    return res;
  }

  async getResourceBillableCount(userId) {
    // console.log('getResourceBillableCount after 1');

    let timeSheet = this.parseService.instance.Object.extend('ResourceStatus');
    let query = new this.parseService.instance.Query(timeSheet);
    query.include('user');
    query.include('user.profile');
    query.include('user.profile.department');
    query.include('user.profile.role');
    let dateStart = this.dateService.startEndDateByDate(this.startbydate);
    let dateEnd = this.dateService.startEndDateByDate(this.endbydate);
    query.greaterThan('createdAt', dateStart[0]);
    query.lessThan('createdAt', dateEnd[1]);
    // query.equalTo('user', { __type: 'Pointer', className: 'Profile', objectId: userId });
    query.limit(10000);
    const billingByRange = await query.find();

    if (billingByRange) {
      this.billingByRange = JSON.parse(JSON.stringify(billingByRange));
      // console.log('billing status by range 2', this.billingByRange);
      return this.billingByRange;
    }

  }

  async getDepartment() {
    await this.getReportingToService.getDepartment().then(res => {
      this.deptOptions = this.bindDropDown(res);
    });
  }

  bindDropDown(array) {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.label, value: a.label });
    });
    return dropDownItem;
  }


  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = this.bindDropDown(res);
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  onResize(event) {
    this.view = [event.target.innerWidth / this.ngxChartWidth, 400];
  }

  onSelect(event) {

  }

  regenerateReport(): void {
    this.isDownloadAsExcel = true;
    this.dataService.add(this.configuration.regenerateResourceAnalyticReport, { tenantId: this.tenantId }).subscribe((data: any) => {
      if (data.isSuccess) {
        this.toastr.success('Report generation successfully completed');
        this.getResourceStatus();
        this.isDownloadAsExcel = false;
      }
      else {
        this.toastr.warning('Something went wrong');
      }
    });
  }

  exportAsXLSX(): void {
    // const resourceStatus = this.resourceStatus;

    const resourceStatus = this.resourceStatus.map(item => {
      delete item['position'];
      delete item['userId'];
      delete item['resourceImg'];
      // delete item['totalExperience'];
      delete item['experience'];
      return {
        Resource_Name: item.name,
        Designation: item.designation,
        Department: item.department,
        Project_Name: item.projectName,
        Reporting_To: item.reportingTo,
        Total_Experience: item.totalExperience,
      };
    });

    this.excelService.exportAsExcelFile(resourceStatus, 'Resource_Analytics');
  }

  // calculate number of days between two dates
  //   parseDate(str): any{
  //     var mdy = str.split('/');
  //     return new Date(mdy[2], mdy[0] - 1, mdy[1]);
  //   }

  //   datediff(first, second): any{
  //     return Math.round((second - first) / (1000 * 60 * 60 * 24));
  // }
}

